/**
 * @generated SignedSource<<59f9722a7bb53866a6400707bce9e9a2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ActionButton_Booking$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useJoinBooking_Booking">;
  readonly " $fragmentType": "ActionButton_Booking";
};
export type ActionButton_Booking$key = {
  readonly " $data"?: ActionButton_Booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"ActionButton_Booking">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ActionButton_Booking",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useJoinBooking_Booking"
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};

(node as any).hash = "6c5dbb166b835bdfde101bde9095d143";

export default node;
